/* eslint-disable */
// @ts-nocheck
import { useEffect, useRef } from 'react'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { constructFullName } from 'utils/supplier/constructFullName'
import { isProductionEnvironment } from './appUtils'

let pendoScriptLoaded = false
let pendoInitialized = false

const loadPendoScript = () => {
  if (pendoScriptLoaded || typeof window === 'undefined') return
  pendoScriptLoaded = true
  ;(function (publicAppId) {
    ;(function (p, e, n, d, o) {
      let v, w, x, y, z
      o = p[d] = p[d] || {}
      o._q = o._q || []
      v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track', 'trackAgent']
      for (w = 0, x = v.length; w < x; ++w)
        (function (m) {
          o[m] =
            o[m] ||
            function () {
              o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)))
            }
        })(v[w])
      y = e.createElement(n)
      y.async = !0
      y.src = 'https://cdn.eu.pendo.io/agent/static/' + publicAppId + '/pendo.js'
      z = e.getElementsByTagName(n)[0]
      z.parentNode.insertBefore(y, z)
    })(window, document, 'script', 'pendo')
  })('56b33065-6482-4387-a199-7982da341cb0')
}

export const PendoProvider = () => {
  const { user, org } = useAuthenticatedUser()
  const lastInitializedOrgId = useRef<string | null>(null)

  useEffect(() => {
    // TODO: remove Josh's sandbox org once Pendo is validated in production
    const JOSH_SANDBOX_ORG_ID = '1dab1897-22eb-44e4-bbc0-eb25c57e1c6c'
    if (!isProductionEnvironment() || org.organisationId !== JOSH_SANDBOX_ORG_ID) return
    if (org.organisationId === lastInitializedOrgId.current) return
    lastInitializedOrgId.current = org.organisationId

    loadPendoScript()

    const pendoData = {
      visitor: {
        id: user.id,
        email: user.email,
        full_name: constructFullName(user.firstName, user.lastName),
        role: user.role,
      },
      account: {
        id: org.organisationId,
        name: org.name,
      },
    }

    if (!pendoInitialized) {
      pendoInitialized = true
      window.pendo.initialize(pendoData)
    } else {
      window.pendo.identify(pendoData)
    }
  }, [org, user])

  return null
}
